import React, { useEffect, useState } from "react";
import WinnerComponent from "../../Components/WinnerComponent/WinnerComponent";
import {
  Apiurl,
  parseData,
  stringifyData,
  GetLocalStorageParsed,
} from "../utils/page";
import axios from "axios";
import Header from "../../Components/Header/Header";
import Footer from "../../Components/Footer/Footer";
import { toast } from "react-toastify";
import Loader from "../../Components/Loader/Loader";
import { Pagination } from "react-bootstrap";

const Winning = () => {
  const FetchToken = GetLocalStorageParsed("AuthToken");
  const getUser = GetLocalStorageParsed("User");

  const [loading, setLoading] = useState("");
  const [pageNumber, setPageNumber] = useState(0);
  const [showAll, setShowAll] = useState(false);
  const [numberOfRecordSelected, setNumberofRecordSelected] = useState();
  const [applyButton, setApplyButton] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    setPageNumber(0);
    setNumberofRecordSelected(10)
  }, []);

  const [filterUserId, setFilteredUsedId] = useState();
  const [combinePromoData, setCombinePromoData] = useState();
  const [promoClickData, setPormoClickData] = useState();

  const [addressList, setAddressList] = useState([]);
  const [getProfileData, setGetProfielData] = useState();
  const [loginToken, setLoginToken] = useState(FetchToken || null);
  const [AllWinnerData, setAllWinnerData] = useState([]);
  const [allData, setAllData] = useState();
  const [filterAllData, setFilterAllData] = useState();
  const [deliveryChargeModal, setDeliveryChargeModal] = useState(false);
  const [show, setShow] = useState(false);
  const [showNewAddress, setShowNewAddress] = useState(false);

  const [selectedAddress, setSelectedAddress] = useState();
  const [clickedData, setClickedData] = useState();
  const [appliedPromoId, setAppliedPromoId] = useState(null);
  const [promoData, setPromoData] = useState();

  const [winnerList, setWinnerList] = useState();
  const fetchAddressList = () => {
    const option = {
      method: "GET",
      headers: {
        accept: "*/*",
        Authorization: `Bearer ${loginToken ? loginToken : ""}`,
      },
      url: `${Apiurl()}/api/Customer/FetchDeliveryAddressList`,
    };
    axios(option)
      .then((e) => {
        const data = parseData(e?.data?.result);
        setSelectedAddress(data?.find((i) => i?.IsDefault === true));
        setAddressList(data);
      })
      .catch((error) => {});
  };
  useEffect(() => {
    fetchAddressList();
  }, []);
  const handleClose = () => {
    setDeliveryChargeModal(false);
  };

  const [StartDate, setStartDate] = useState();
  const [EndDate, setEndDate] = useState();
  const [Filterdata, setFilterdata] = useState("");
  const [totalRecord, setTotalRecord] = useState();
  const [deliveryCharge, setDeliveryCharge] = useState();
  const [totalValue, setTotalValue] = useState();
  const [promoDataEmail, setPromoDataEmail] = useState();
  const [paymentFailed, setPaymentFailed] = useState();

  const [finalValue, setFinalValue] = useState();

  const handleFilterAchievemnt = () => {
    setEndDate("");
    setStartDate("");
    setShowAll(true);

    const filterData = winnerList?.filter(
      (item) => item?.Email === getProfileData?.Email
    );
    setFilterAllData(filterData);
    setTotalRecord(filterData?.length);
  };
  const getPromo = () => {
    const option = {
      method: "GET",
      headers: {
        accept: "*/*",
        Authorization: `Bearer ${loginToken || " "}`,
      },
      url: `${Apiurl()}/api/PromoCode/GetPromoCodesLimitedUsers`,
    };
    axios(option)
      .then((e) => {
        setPromoData(parseData(e?.data?.result));
      })
      .catch((error) => {});
  };
  // const groupData = (data) => {
  //   return data?.reduce((acc, item) => {
  //     const formattedDate = item.Date.split("T")[0]; // Extract date without time
  //     const key = `${item.ProductId}-${formattedDate}`;

  //     if (!acc[key]) {
  //       acc[key] = {
  //         ProductId: item.ProductId,
  //         ProductName: item.ProductName,
  //         Date: formattedDate,
  //         ProductImageURL: JSON.parse(item.ProductImageURL || "[]"), // Safely parse JSON
  //         DeliveryCharges: item?.DeliveryCharges,

  //         Users: [],
  //       };
  //     }
  //     acc[key].Users.push({
  //       Username: item.Username,
  //       Email: item.Email,
  //       UserId: item.UserId,
  //       UserImageURL: item?.UserImageURL,
  //       Id: item?.Id,
  //       IsClaimed: item?.IsClaimed,
  //     });

  //     return acc;
  //   }, {});
  // };

  // Get Vendors
  const GetWinnerList = () => {
    // setLoading("winner")
    const option = {
      method: "GET",
      headers: {
        accept: "*/*",
        Authorization: `Bearer ${loginToken ? loginToken : ""}`,
      },
      url: `${Apiurl()}/api/Customer/GetWinners`,
    };
    axios(option)
      .then((e) => {
        setShowAll(false);
        const data = parseData(e.data.result);
        setWinnerList(data);
      })
      .catch((error) => {
        console.error(error);
      });
  };
  useEffect(() => {
    GetWinnerList();
  }, []);
  // useEffect(() => {
  //   if (EndDate && !showAll) {
  //     const filter = filterAllData?.sort((a, b) => a.Date);
  //   }
  // }, [EndDate]);
  useEffect(() => {
    if (StartDate && EndDate && showAll) {
      // Always filter from the original list (winnerList)
      const filtered = winnerList?.filter((item) => {
        const itemDate = new Date(item.Date);
        return (
          itemDate >= new Date(StartDate) &&
          itemDate <= new Date(EndDate) &&
          item?.Email === getProfileData?.Email
        );
      });

      setFilterAllData(filtered);
      setTotalRecord(filtered?.length);
    }
  }, [StartDate, EndDate, showAll, winnerList]);

  const GetNewWinner = (e, pagination, selected) => {
    if (pagination === "pag") {
      setPageNumber(e);
    }
  
    setLoading("winner");
  

    const data = {
      to: e === "All" ? null : EndDate || null,
      from: e === "All" ? null : StartDate || null,
      pagination: {
        pageNumber: pagination === "pag" ? e : 1 || 1,
        pageSize:
          e === "All" ? 0 : selected ? selected : numberOfRecordSelected,
      },
    };
    const option = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${loginToken || " "}`,
      },
      data: stringifyData(data),
      url: `${Apiurl()}/api/Customer/GetAllWinnersFromBid`,
    };
    axios(option)
      .then((e) => {
        if (e?.data?.status === "OK") {
          // setShowAll(false);
          setTotalRecord(e?.data?.totalRecords);
          if (e?.data?.totalRecords < 10) {
            setNumberofRecordSelected(10);
            setPageNumber(0);
          }

          setFilterdata(parseData(e.data.result));
          const data = parseData(e.data.result);
          setAllData(data);
          // const grouped = groupData(data);
          setAllWinnerData(data);
          setLoading("");
        }
      })
      .catch((error) => {});
    // }
  };
  useEffect(() => {
    GetNewWinner();
  }, []);
  useEffect(() => {
    if (EndDate && !showAll) {
      setShowAll(false);
      GetNewWinner();
    }
  }, [EndDate]);

  const handleClicked = (item) => {
    setTotalValue(item?.DeliveryCharges);

    setClickedData(item);
    const UserId = item?.Users?.find(
      (i) => i?.UserId == JSON.parse(getUser)?.nameid
    );
    setFilteredUsedId(UserId);
  };
  const handleClaim = () => {
    const data = {
      DeliveryAddressId: selectedAddress?.Id,
      ProductId: clickedData?.ProductId,
      UserId: filterUserId?.UserId,
      Id: null,
      Date: new Date(),
      Status: "In Progress",
      IsClamied: null,
      IsPromoApplied: null,
      TotalAmountInformation: null,
      PromoCodeId: null,
      PayableAmount: null,
      ClaimedDate: new Date(),
      TransactionId: null,
      pickUpLocationId: null,
      PaymentStatus: null,
      IsPaymentSuccess: null,

      // userId:
    };

    const option = {
      method: "POST",
      headers: {
        accept: "*/*",
        Authorization: `Bearer ${loginToken ? loginToken : ""}`,
      },
      data: data,
      url: `${Apiurl()}/api/Customer/ClaimWinningProduct`,
    };
    axios(option)
      .then((e) => {
        if (e?.data?.status === "OK") {
          if (totalValue > 0) {
            handlePay(parseData(e?.data?.result));
          } else {
            toast.success(e?.data?.message);
            setFilterAllData();

            setShow();
            setShowNewAddress(false);
            GetNewWinner();
          }
        }
        if (e?.data?.status === "BadRequest") {
          toast.error(e?.data?.message);
        }
      })
      .catch((error) => {});
  };
  const totalPages = Math.ceil(totalRecord / (numberOfRecordSelected || 10));
  const handleNextPage = () => {
    if (pageNumber < totalPages - 1) {
      GetNewWinner(pageNumber + 1, "pag");
    }
  };

  const handlePrevPage = () => {
    if (pageNumber > 0) {
      GetNewWinner(pageNumber - 1, "pag");
    }
  };

 

  const getPromoCodeByEmail = (item) => {
    const data = {
      email: getProfileData?.Email,
    };
    const option = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        // 'Authorization': `Bearer ${loginToken || " "}`
      },
      data: stringifyData(data),
      url: `${Apiurl()}/api/PromoCode/GetPromoCodesByEmail`,
    };
    axios(option)
      .then((e) => {
        setPromoDataEmail(parseData(e?.data?.result));
      })
      .catch((error) => {});
  };

  useEffect(() => {
    getPromo();
    // getDeliveryCharge();
  }, []);
  useEffect(() => {
    if (getProfileData) {
      getPromoCodeByEmail();
    }
  }, [getProfileData]);
  const handleApplyPromo = (item) => {
    setAppliedPromoId(item.Id);

    setPormoClickData(item);

    setApplyButton(true);
    const adjustedFinalValue = Math.max(
      0,
      clickedData?.DeliveryCharges - (item?.MinAmount || 0)
    ); // Ensures result is at least 0
    setFinalValue(adjustedFinalValue);
    const data = {
      Id: item?.Id,
    };
    const option = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        // 'Authorization': `Bearer ${loginToken || " "}`
      },
      data: stringifyData(data),
      url: `${Apiurl()}/api/PromoCode/GetPromoCodeById`,
    };
    axios(option)
      .then((e) => {
        const data = parseData(e?.data?.result);
      })
      .catch((error) => {});
  };
  const handleRemovePromo = () => {
    setAppliedPromoId(null);

    setApplyButton(false);
    setFinalValue(clickedData?.DeliveryCharges);
    setTotalValue(clickedData?.DeliveryCharges);
  };
  useEffect(() => {
    const combine = [...(promoData || []), ...(promoDataEmail || [])];
    setCombinePromoData(combine);
  }, [promoDataEmail, promoData]);
  const handlePay = async (item) => {
    // return
    const options = {
      key: "rzp_live_SEIuC9F9Y9pG1r", //live
      // key: "rzp_test_0F6zCrTs97XdnP", //test
      amount: stringifyData(totalValue * 100),
      currency: "INR",
      name: "Shop Saverz",
      description: "Payment for Order or money for wallet",
      // order_id: orderId,
      prefill: {
        name: getProfileData?.Name,
        email: getProfileData?.Email,
        contact: getProfileData?.PhoneNumber,
      },
      handler: async (response) => {
        handleAfterPayment(response?.razorpay_payment_id);
      },
    };
    const paymentObject = new window.Razorpay(options);

    // Listen for payment success
    paymentObject.on("payment.success", (response) => {});

    // Listen for payment failure
    paymentObject.on("payment.failed", (response) => {
      setPaymentFailed(response);
    });
    paymentObject.open();
  };

  const handleAfterPayment = (transId) => {
    const data = {
      DeliveryAddressId: null,
      ProductId: clickedData?.ProductId,
      UserId: null,
      Id: null,
      Date: new Date(),
      Status: null,
      IsClamied: null,
      IsPromoApplied: appliedPromoId ? appliedPromoId : null,
      TotalAmountInformation: null,
      PromoCodeId: null,
      PayableAmount: totalValue,
      ClaimedDate: null,
      TransactionId: transId,
      IsPaymentSuccess: paymentFailed ? false : true,
      PaymentStatus: paymentFailed ? paymentFailed?.error?.description : " ",
    };

    const option = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${loginToken}`,
      },
      data: stringifyData(data),
      url: `${Apiurl()}/api/Customer/ClaimWinningProduct`,
    };
    axios(option)
      .then((e) => {
        if (e?.data?.status === "OK") {
          toast.success(e?.data?.message);
          setFilterAllData();

          setShow();
          setShowNewAddress(false);
          GetNewWinner();
        }
        if (e?.data?.status === "BadRequest") {
          toast.error(e?.data?.message);
        }
      })
      .catch((error) => {});
  };

  const [pageIndex, setpageIndex] = useState(1);
  const [pageArray, setpageArray] = useState();
  const [totalRec, settotalRec] = useState();
  const [showingFrom, setshowingFrom] = useState(1);
  const [showingTo, setshowingTo] = useState(10);
  const changePage = (item) => {
    if (item === "...") {
      return;
    }
    setpageIndex(item);
    GetNewWinner(item, "pag");
  };
  const prevPage = () => {
    if (pageIndex === 1) {
      return;
    }
    setpageIndex(pageIndex - 1);
    GetNewWinner(pageIndex - 1, "pag");
  };
  const nextPage = () => {
    if (pageIndex === totalPages) {
      return;
    }
    setpageIndex(pageIndex + 1);
    GetNewWinner(pageIndex + 1, "pag");
  };
  const pagination = () => {
    var current = pageIndex,
      last = totalPages,
      delta = 2,
      left = current - delta,
      right = current + delta + 1,
      range = [],
      rangeWithDots = [],
      l;
    for (let i = 1; i <= last; i++) {
      if (i == 1 || i == last || (i >= left && i < right)) {
        range.push(i);
      }
    }
    for (let i of range) {
      if (l) {
        if (i - l === 2) {
          rangeWithDots.push(l + 1);
        } else if (i - l !== 1) {
          rangeWithDots.push("...");
        }
      }
      rangeWithDots.push(i);
      l = i;
    }
    setpageArray(rangeWithDots);
  };
  useEffect(() => {
    pagination();
  }, [totalPages, pageIndex]);

  useEffect(() => {
    if (totalRecord == 0) {
      setshowingFrom(0);
      setshowingTo(0);
      return;
    }
    if (totalRecord <= Number(numberOfRecordSelected )) {
      setshowingFrom(1);
      setshowingTo(totalRecord);
      return;
    }
    setshowingTo(pageIndex * numberOfRecordSelected);
    setshowingFrom(
      pageIndex * numberOfRecordSelected - (numberOfRecordSelected - 1)
    );
    if (pageIndex * numberOfRecordSelected >= totalRecord) {
      setshowingTo(totalRecord);
    }
  }, [pageIndex, numberOfRecordSelected, totalRecord]);

  return (
    <div
      style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}
    >
      {loading === "winner" ? (
        <div className="loading-container">
          <Loader />
        </div>
      ) : null}

      <Header
        setGetProfielData={setGetProfielData}
        setLoginToken={setLoginToken}
        setLoading={setLoading}
      />

      <WinnerComponent
        AllWinnerData={AllWinnerData}
        GetNewWinner={GetNewWinner}
        loading={loading}
        EndDate={EndDate}
        setEndDate={setEndDate}
        StartDate={StartDate}
        setStartDate={setStartDate}
        Filterdata={Filterdata}
        loginToken={loginToken}
        handleFilterAchievemnt={handleFilterAchievemnt}
        showAll={showAll}
        setDeliveryChargeModal={setDeliveryChargeModal}
        deliveryChargeModal={deliveryChargeModal}
        handleClose={handleClose}
        setShow={setShow}
        show={show}
        addressList={addressList}
        setAddressList={setAddressList}
        fetchAddressList={fetchAddressList}
        setSelectedAddress={setSelectedAddress}
        selectedAddress={selectedAddress}
        setClickedData={setClickedData}
        clickedData={clickedData}
        setFilteredUsedId={setFilteredUsedId}
        filterUserId={filterUserId}
        handleClaim={handleClaim}
        handleClicked={handleClicked}
        filterAllData={filterAllData}
        getProfileData={getProfileData}
        setFilterAllData={setFilterAllData}
        numberOfRecordSelected={numberOfRecordSelected}
        setShowAll={setShowAll}
        totalRecord={totalRecord}
        setNumberofRecordSelected={setNumberofRecordSelected}
        pageNumber={pageNumber}
        handlePrevPage={handlePrevPage}
        handleNextPage={handleNextPage}
        setPageNumber={setPageNumber}
        deliveryCharge={deliveryCharge}
        combinePromoData={combinePromoData}
        appliedPromoId={appliedPromoId}
        handleApplyPromo={handleApplyPromo}
        handleRemovePromo={handleRemovePromo}
        applyButton={applyButton}
        totalValue={totalValue}
        finalValue={finalValue}
        setShowNewAddress={setShowNewAddress}
        showNewAddress={showNewAddress}
        // pageNumbers={pageNumbers}
        totalPages={totalPages}
        setpageIndex={setpageIndex}
        prevPage={prevPage}
        pageArray={pageArray}
        changePage={changePage}
        pageIndex={pageIndex}
        nextPage={nextPage}
        showingFrom={showingFrom}
        showingTo={showingTo}
      />
      <Footer />
    </div>
  );
};
export default Winning;
